import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconWrenchFill.tsx
const IconWrenchFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M25.665 9.163a1.335 1.335 0 0 1 2.193.479A9.34 9.34 0 0 1 25.71 19.5a9.33 9.33 0 0 1-9.734 2.192l-5.35 5.35a4 4 0 1 1-5.658-5.657l5.35-5.35a9.335 9.335 0 0 1 12.033-11.89 1.335 1.335 0 0 1 .481 2.194l-3.141 3.142a2.001 2.001 0 0 0 2.828 2.828z"
	})]
});
var IconWrenchFill_default = forwardRef(IconWrenchFill);
//#endregion
export { IconWrenchFill_default as default };
